import type { ReactElement } from "react";

import { useSelector } from "react-redux";

import {
    ColumnsSelectionModal,
    type SelectionModalProps,
} from "app/pages/sales-intelligence/common-components/column-picker";
import { useAppsColumnSelectionPlugins } from "app/pages/sales-intelligence/modules/apps-search/hooks/useAppsColumnSelectionPlugins";
import { COLUMN_CATEGORIES } from "app/pages/sales-intelligence/pages/find-apps/configuration/categoryConfig";
import useColumnSelectionOptions from "app/pages/sales-intelligence/pages/find-apps/hooks/useColumnSelectionOptions";
import useUpdateColumnSelection from "app/pages/sales-intelligence/pages/find-apps/queries/useUpdateColumnSelection";
import { selectActiveAppSourceType } from "app/pages/sales-intelligence/store/find-apps/selectors";

import { SELECTION_MODAL_TITLE } from "./const";

const SelectionModalContainer = ({ isOpen, closeModal }: SelectionModalProps): ReactElement => {
    const activeAppSourceType = useSelector(selectActiveAppSourceType);
    const { mutateAsync, isPending } = useUpdateColumnSelection(activeAppSourceType);

    const [selected, available] = useColumnSelectionOptions(activeAppSourceType);

    const { config, pluginCleanup } = useAppsColumnSelectionPlugins();

    const handleCloseModal = (): void => {
        closeModal();
        pluginCleanup();
    };

    const handleApply = async (columns: readonly string[]): Promise<void> => {
        await mutateAsync({ columns });
        handleCloseModal();
    };

    return (
        <ColumnsSelectionModal
            isOpened={isOpen}
            isApplyPending={isPending}
            title={SELECTION_MODAL_TITLE[activeAppSourceType]}
            initialSelectedColumnIds={selected}
            columnOptions={available}
            categoryConfig={COLUMN_CATEGORIES}
            pluginConfig={config}
            onApply={handleApply}
            onCancel={handleCloseModal}
        />
    );
};

export default SelectionModalContainer;
